import { FirstLoginFeature } from 'interfaces/subscribe.types';
import { useQuery } from 'react-query';
import { SubscribeAPI } from 'services/subscribe.api';

/**
 * Hook React Query pour récupérer la feature flag first_login.
 * GET /features?name=first_login
 *
 * En cas d'erreur API, retourne un fallback { enabled: false } afin de ne pas
 * bloquer le formulaire ni impacter le comportement par défaut.
 */
export function useFirstLoginFeature() {
  return useQuery<FirstLoginFeature, Error>(
    'firstLoginFeature',
    async () => {
      const { data } = await SubscribeAPI.getFirstLoginFeature();
      // L'API retourne un tableau, on prend le premier élément
      const feature = Array.isArray(data) ? data[0] : data;
      return feature ?? { enabled: false };
    },
    {
      staleTime: 5 * 60 * 1000,
      retry: 1,
      // En cas d'échec, on ne bloque pas : le form utilisera les valeurs par défaut
      placeholderData: { enabled: false },
    },
  );
}
